import Nav from './nav';
import ExtraInfo from './ExtraInfo.js';
import ProgressBar from './ProgressBar';
import './style.css';

const Header = () => (
  <>
    <ExtraInfo />
    <ProgressBar />
    <header className="header">
      <Nav />
    </header>
  </>
);

export default Header;
